import React, {useContext} from 'react';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';

import BucketContext from '../context/BucketContext';
import * as Consts from '../constants/Consts';
import * as CustomStyles from '../styles/CustomStyles';
import * as Formatter from '../util/Formatter';
import * as TypeConvertor from '../util/TypeConvertor';
import { DispatchAF } from '../AFStoreDispatchAction';

export const UpdateDetailsSection = (props) => {
    return(
        <Grid container spacing={2} sx={CustomStyles.gridStyles}>
            {/*row*/}
            <Grid item xs={3}>
                <Typography color="text.primary" paddingTop={0} >Modificat de</Typography>
            </Grid>
            <Grid item xs={9}>
                {props.entity.updateBy?.updateByFullName ?
                    props.entity.updateBy.updateByFullName + ' - ' + props.entity.updateBy.updateByClient
                        :
                    ''
                }
            </Grid>

            {/*row*/}
            <Grid item xs={3}>
                <Typography color="text.primary" paddingTop={0} >Data modificare</Typography>
            </Grid>
            <Grid item xs={9}>
                {Formatter.formatDateTimetoRO(props.entity.updateDate)}
            </Grid>
        </Grid>
    );
};


export const ClientContextSection = (props) => {
    const bucketContext = useContext(BucketContext);

    var contextClientId = '';
    if( !!bucketContext.bucket.userContext?.clientId /* && props.status === ReduxDataStatus.SUCCEEDED */){
        contextClientId = bucketContext.bucket.userContext.clientId != Consts.COREVO_CLIENT_ID ? bucketContext.bucket.userContext.clientId : '';
    }

    const clientSelectData = TypeConvertor.getClientSelectData(props.clients);
    const [selectedClientId, setSelectedClientId] = React.useState( contextClientId );

    const handleClientChange = (clientId) => {
        setSelectedClientId(clientId);
        bucketContext.setBucketValue({userContext: {clientId: clientId}});
        DispatchAF.fetchSubcontracted(clientId);
    }

    return (
        <FormControl fullWidth size="small" margin="dense" variant="standard">
            <InputLabel id={'daAngajator-inputLabelId'}>Client</InputLabel>
            <Select
                labelId={'daClient-selectLabelId'}
                id={'daClient'}
                value={selectedClientId}
                onChange={(event) => handleClientChange(event.target.value) } 
                label={'daClient-label'}
            >
                {
                    clientSelectData.map((data) => <MenuItem dense value={data.id} key={data.id}> {data.name} </MenuItem>)
                }
            </Select>
        </FormControl>
    );
}
